import axios from "axios";

// Create an axios instance
const api = axios.create({
  baseURL: "https://mlm-break.fischerjordan.xyz",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const handleApiError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    console.error(
      `Response error: Status ${status}, API called: ${
        error.config.url
      }, data: ${JSON.stringify(
        data
      )}, Response error: Status ${status},  API called: ${error.config.url}`
    );

    return {
      data:
        data?.message ||
        data?.detail ||
        "We encountered an issue on our end. Please try again.",
      status: "error",
      code: status,
    };
  } else if (error.request) {
    console.error("No response received:", error.request);
    return {
      data: "No response received from the server",
      status: "error",
      code: 503,
    };
  } else {
    console.error("Error in setting up the request:", error.message);
    return {
      data: "Error in setting up the request",
      status: "error",
      code: 500,
    };
  }
};

//function to perform registration
const userRegistrationAPI = async (payload) => {
  try {
    const {
      email,
      password,
      name,
      phone,
      dynamicUrl,
      additionalData = {},
    } = payload;
    const response = await api.post(`/api/community/${dynamicUrl}/`, {
      email,
      password,
      name,
      phone,
      ...additionalData,
    });
    if (response.status >= 200 && response.status < 300) {
      const data = response.data;
      return { data, status: "success" };
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

//function to perform login
const loginAPI = async (username, password) => {
  try {
    const response = await api.post("/api/auth_token/", { username, password });
    if (response.status >= 200 && response.status < 300) {
      const token = response.data.token;
      const logStats = { token, status: "success", data: response.data };
      return logStats;
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

//function to perform password reset
const resetPasswordAPI = async (email, old_password, new_password) => {
  try {
    const response = await api.post("/api/change_password/", {
      email,
      old_password,
      new_password,
    });
    if (response.status >= 200 && response.status < 300) {
      const token = response.data.token;
      const logStats = { token, status: "success", data: response.data };
      return logStats;
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

//function to perform password reset
const forgotPasswordAPI = async (email) => {
  try {
    const response = await api.post("/api/forgot_password/", { email });
    if (response.status >= 200 && response.status < 300) {
      const token = response.data.token;
      const logStats = { token, status: "success", data: response.data };
      return logStats;
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

// Function to get section_break_results
const getSectionBreakResAPI = async (email) => {
  try {
    const response = await api.get(`/api/section_break/${email}`);
    if (response.status >= 200 && response.status < 300) {
      const sectionBreakResults = {
        data: response.data,
        status: "success",
      };
      return sectionBreakResults;
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

//function to save current question
const saveCurrentQuestonAPI = async (payload) => {
  try {
    const response = await api.post("/api/save_current_question/", payload);
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//function to get model responses
const getModelResponseAPI = async (email) => {
  try {
    const response = await api.get(`/api/model_response/${email}`);
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Function to check token
const checkPaymentTokenAPI = async (campaign, checkout_session_id) => {
  try {
    const response = await api.post("/api/verify_checkout/", {
      campaign,
      checkout_session_id,
    });
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Function to post query
const postQueryAPI = async (email, name, query) => {
  try {
    const response = await api.post("/api/helpdesk_query/", {
      email,
      name,
      query,
    });
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//function to verify user registration with otp
const reportPageStaticDetailsAPI = async () => {
  try {
    const response = await api.get(`/api/report_page/`);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//below apis are not being used in the App
// Function to check token
const checkTokenAPI = async (username, password) => {
  try {
    const response = await api.post("/api/break_portal_auth/", {
      username,
      password,
    });
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//function to delete User Response Request
const deleteUserResponseRequestAPI = async (email) => {
  try {
    const response = await api.delete(`/api/delete_user_response/${email}`);
    if (response.status >= 200 && response.status < 300) {
      return { status: "success" };
    } else {
      return handleApiError(response);
    }
  } catch (error) {
    return handleApiError(error);
  }
};

//function to delete User Timeline Response Request
const deleteUserTimelineResponseRequestAPI = async (email) => {
  try {
    const response = await api.delete(
      `/api/delete_user_timeline_response/${email}`
    );
    if (response.status >= 200 && response.status < 300) {
      return { status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Function to get user status of the start page
const getStartPageStatusAPI = async (email) => {
  try {
    const response = await api.get(`/api/get_user_start_status/${email}`);
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

// Function to get user status of the start page
const sendStartPageStatusAPI = async (email, status) => {
  try {
    const response = await api.post("/api/update_user_status/", {
      email,
      status,
    });
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, status: "success" };
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

//function to verify user registration with otp
const verifyOtpAPI = async (email, otp) => {
  try {
    const response = await api.post(`/api/verify_user_otp/${email}/`, { otp });
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else return handleApiError(response);
  } catch (error) {
    return handleApiError(error);
  }
};

export {
  userRegistrationAPI,
  loginAPI,
  getSectionBreakResAPI,
  saveCurrentQuestonAPI,
  getModelResponseAPI,
  checkPaymentTokenAPI,
  postQueryAPI,
  resetPasswordAPI,
  forgotPasswordAPI,
  reportPageStaticDetailsAPI,
  //below are not being used in the App for now
  checkTokenAPI,
  deleteUserResponseRequestAPI,
  deleteUserTimelineResponseRequestAPI,
  getStartPageStatusAPI,
  sendStartPageStatusAPI,
  verifyOtpAPI,
};
